import { IStore } from 'src/interfaces/store';

/**
 * Group sources by area
 *
 * @param {ISource[]} sources
 * @return {*}
 */
export const groupStores = (stores: IStore[]) => {
    const groupedStores = stores.reduce(
        (acc: Record<string, IStore[]>, store) => {
            const make = store.make?.name;

            if (!make) return acc;

            const makeName = make.toLowerCase();
            if (!acc[makeName]) {
                acc[makeName] = [];
            }
            acc[makeName].push(store);
            return acc;
        },
        {}
    );

    Object.keys(groupedStores).forEach((store) => {
        groupedStores[store] = groupedStores[store].sort((a, b) =>
            a.name.localeCompare(b.name, 'es', { sensitivity: 'base' })
        );
    });

    return groupedStores;
};
